// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__5jRgH","footer":"ModalFilter_footer__3T_Br"};